// #288 — eval 사진 URL 파서 (상대/절대 겸용)
// DB photos[].url 은 원래 상대경로(/uploads/eval/<orderId>/<filename>)지만,
// 운영 .env PUBLIC_BASE_URL 미설정 시기(≤2026-07-29)에 업로드된 건은
// 절대 URL(https://test.autodex.kr/uploads/eval/...)로 저장돼 있다.
// 소비처(썸네일/라이트박스/다운로드)는 도메인을 무시하고 orderId/filename 만
// 뽑아 API 엔드포인트를 조립해야 한다 — 앞부분 고정(^) 매칭 금지.
var EVAL_PHOTO_RE = /\/uploads\/eval\/(\d+)\/([^/?#]+)/;

// url → { orderId, filename } | null (eval 사진 경로가 아니면 null)
export function parseEvalPhotoUrl(url) {
  var m = (url || '').match(EVAL_PHOTO_RE);
  return m ? { orderId: m[1], filename: m[2] } : null;
}

export { EVAL_PHOTO_RE };
